<template>
  <div class="leapin-identity-page">
    <header-component :type="headerType"></header-component>
    <div class="identity-content">
      <!-- banner -->
      <div class="banner">
        <div class="bg-box">
          <div class="shadow-box1"></div>
          <div class="shadow-box2"></div>
          <div class="title-box">
            <div class="title">The World's Marketplace</div>
            <div class="title">of Jobs of Tomorrow</div>
            <div class="lip-button but" @click="$router.push('/Login?type=1')">
              <img :src="lightStar" />&nbsp;Join for free
            </div>
          </div>
        </div>
        <div class="introduce">
          IN THE AGI ERA, ONLY <img :src="logo_home" /> HAS THE RIGHT COMBINATION OF <br>
          SKILLS MATCHING WITH THE WORK MARKETPLACE.
        </div>
      </div>
      <!-- 身份选择 -->
      <div class="chioce">
        <div class="chioce-item">
          <img :src="seeker" />
          <div class="box" @click="selectRole('seeker')">
            <span>For <span class="stress">Talent</span></span>
            <div class="ciecle"><img :src="chioce" /></div>
          </div>
        </div>
        <div class="chioce-item" @click="selectRole('coach')">
          <img :src="coach" />
          <div class="box">
            <span>For <span class="stress">Professionals</span></span>
            <div class="ciecle"><img :src="chioce" /></div>
          </div>
        </div>
      </div>
      <!-- why choose Unfolds -->
      <!-- <div class="why-choose-us"></div> -->

      <!-- find-jobs -->
      <div class="find-jobs">
        <div class="content">
          <el-row>
            <el-col :span="14">
              <div class="title">FIND JOBS</div>
              <div class="tip">Get matched to high-paying jobs</div>
              <div class="word">
                Unfolds offers a wide range of remote, full time roles tailored to software developers, data scientists, engineers, and business specialists. 
              </div>
              <div class="word">
                Unfolds goes beyond traditional methods by using AI-powered matching to connect you with opportunities that align perfectly with your skills and career goals.
              </div>
            </el-col>
            <el-col :span="8" :offset="2">
              <div class="img-box">
                <img :src="find_jobs_bg" />
              </div>
            </el-col>
          </el-row>
          <div class="line-img">
            <img class="line" :src="find_jobs_line" />
            <img class="black-c" :src="find_jobs_black_circle" />
            <img class="green-c" :src="find_jobs_green_circle" />
          </div>
        </div>
      </div>
      <!-- become a profession -->
      <div class="become-profession">
        <div class="bp-content">
          <div class="bp-title">BECOME A UNFOLDS PROFESSIONALS</div>
          <div class="bp-tip">FIND WELL-PAID JOBS IN 4 EASY STEPS</div>
          <div class="lip-button bp-but" @click="$router.push('/Login?type=2')">
            <img :src="lightStar" />&nbsp;Join for free
          </div>
          <el-row :gutter="24">
            <el-col :span="6" v-for="(item,index) in bpList" :key="index">
              <div class="bp-item">
                <div class="bp-item-bg">
                  <div class="number">{{ index + 1 }}</div>
                  <div class="bp-item-title">{{ item.title }}</div>
                  <div class="bp-item-content">{{ item.text }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- be a free -->
      <div class="be-a-free">
        <div class="bf-shadow"></div>
        <div class="bf-content">
          <div class="bf-content-top">
            <el-row>
              <el-col :span="12">
                <div class="bf-top-title">
                  BE A FRACTIONAL LEADER
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bf-top-content">
                  <p>
                    If you have deep experience in a field- from 
                    business development to personal styling- you 
                    can offer your consultations at Unfolds platform.
                  </p>
                  <p>The platform is free to join and you can set your own pay rates;</p>
                  <p>Give everyone access to anyone to empowering each other.</p>
                </div>
                <div class="lip-button bp-but leapin-mt-25" @click="$router.push('/Login?type=2')">
                  <img :src="lightStar" />&nbsp;Join for free
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="bf-content-bottom">
            <el-row>
              <el-col :span="12">
                <div class="bf-bottom-img">
                  <div class="avtor color-1"><img :src="free1" /></div>
                  <div class="avtor color-2"><img :src="free2" /></div>
                  <div class="avtor color-3"><img :src="free3" /></div>
                  <div class="avtor color-4"><img :src="free4" /></div>
                  <img class="line" :src="lineImg" />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bf-bottom-content">
                  Join a community of passionate experts and thought-leaders
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="be-content-top">
          <div class="bg-light-ciecle-1 bg-position-1"></div>
          <div class="bg-light-ciecle-2 bg-position-2"></div>
          <div class="be-title">BECOME A UNFOLDS EXPERTS</div>
          <div class="be-tip">Give Everyone Access To Anyone</div>
          <div class="be-item-list">
            <el-row :gutter="24">
              <el-col :span="6" :offset="3">
                <div class="be-item be-bg-1">
                  <div class="be-num">1</div>
                  <div class="title">Create Your Profile</div>
                  <div class="content">Let us get to know you. Fill in your basic details, expertise, work experience to optimize your profile.</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="be-item be-bg-2">
                  <div class="be-num">2</div>
                  <div class="title">Get Personalized Recommendations</div>
                  <div class="position-be content">Receive recommendations for your expertise</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="be-item be-bg-3">
                  <div class="be-num">3</div>
                  <div class="title">Schedule Meeting Directly</div>
                  <div class="content">Start consulting meetings</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- become a expearts -->
      <div class="become-experts">
        <div class="be-content-bottom">
          <div class="bg-light-ciecle-2 bg-position-3"></div>
          <div class="bg-light-ciecle-1 bg-position-4"></div>
          <el-row :gutter="30">
            <el-col :span="12" >
              <p class="be-title">FUTURE SKILLS LAB</p>
              <div class="be-bottom-content">
                <p>Unfolds Future Skills Lab is designed to enableindividuals to learn for life, pursue skills mastery, anddevelop fulfilling careers for a future-ready workforce.</p>
                <p>The Future Skills Lab offers quality, market-driventraining services that bridge the gap between NOW and the FUTURE.</p>
                <p>It empowers people of all ages and industries to acquirewell-rounded knowledge,encompassing technicalexpertise,communication skills, and management abilities.</p>
              </div>
            </el-col>
            <el-col :span="12" class="leapin-text-center">
              <img class="be-bottom-img" :src="skill_centre" />
            </el-col>
          </el-row>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import { head } from 'lodash';

export default {
  components: {
    HeaderComponent: () => import('@/components/header/Header.vue')
  },
  name: 'Identity',
  data() {
    return {
      headerType: 'white',
      scrollPosition: 0, // 用于存储滚动位置
      skill_centre: require('@/assets/images/identity/skill-centre.png'),
      lineImg: require('@/assets/images/identity/line.png'),
      free1: require('@/assets/images/identity/free-1.png'),
      free2: require('@/assets/images/identity/free-2.png'),
      free3: require('@/assets/images/identity/free-3.png'),
      free4: require('@/assets/images/identity/free-4.png'),
      bpList: [
        {
          title: 'Create Your Profile',
          text: 'Let us get to know you. Fill in your basic details, skills, rate, and work experience to optimize your profile.'
        },
        {
          title: 'Complete Our Skills-based Assessment',
          text: 'Complete our required skill assessments and live interviews matched to your experience.'
        },
        {
          title: 'Get Personalized Job Recommendations',
          text: 'Receive recommendations for roles at global that match your expertise and career goals.Or apply to available roles based on your skills.'
        },
        {
          title: 'Start Your Dream Job',
          text: 'Start working with one of our high-profile clients. Enjoy seamless onboarding and continuous support.'
        }
      ],
      find_jobs_line: require('@/assets/svgs/identity-line.svg'),
      find_jobs_green_circle: require('@/assets/svgs/identity-green-c.svg'),
      find_jobs_black_circle: require('@/assets/svgs/identity-black-c.svg'),
      find_jobs_bg: require('@/assets/images/identity/find-jobs-bg.png'),
      logo_home: require('@/assets/svgs/logo-homepage.svg'),
      lightStar: require('@/assets/images/identity/light.png'),
      chioce: require('@/assets/images/identity/choice.png'),
      circle: require('@/assets/svgs/circle.svg'),
      coach: require('@/assets/images/identity/talent.png'),
      seeker:  require('@/assets/images/identity/profession.png'),
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollPosition = window.scrollY; // 垂直滚动距离
      this.headerType = this.scrollPosition > 671 ? 'black' : 'white';
    },
    selectRole(role) {
      console.log(JSON.stringify(this.$store.getters.userInfo))
      if (this.$store.getters.userInfo != undefined) { //表示已经登陆过
        if (role === 'seeker') {
          this.$router.push(this.$store.getters.userInfo.extra_info == null || this.$store.getters.userInfo.extra_info.is_completed == false ? '/CandidateInfo' : 'CandidateReport')
        } else {
          this.$router.push(this.$store.getters.userInfo.extra_info == null || this.$store.getters.userInfo.extra_info.is_completed == false  ? '/CoachInfo' : 'CoachShow')
        }
      } else {
        sessionStorage.setItem('role', role)
        this.$router.push(`/Login?type=${role === 'seeker' ? 1 : 2}`)
      }
      
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>
<style lang="scss" scoped>
.leapin-identity-page {
  min-height: 100vh;
  background-size: cover;
  background: #fff;
  .lip-button {
    padding: 10px 20px;
    border-radius: 120px;
    background: #6E62E5;
    display: flex;
    width: fit-content;
    justify-content: center;
    align-items: center;
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 19.2px;
    font-style: normal;
    font-weight: 400;
    line-height: 26.4px; /* 137.5% */
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .identity-content {
    margin: 0px 20px;
    .banner {
      width: 100%;
      height: 950px;
      .bg-box {
        width: 100%;
        height: 750px;
        background: url('~@/assets/images/identity/banner-bg.png') no-repeat center center;
        background-size: cover;
        position: relative;
        z-index: 0;
        overflow: hidden;
        .shadow-box1 {
          left: 87px;
          bottom: -200px;
          position: absolute;
          z-index: 1;
          width: 646px;
          height: 646px;
          border-radius: 646px;
          background: linear-gradient(180deg, #4A299C 0%, #142A97 100%);
          filter: blur(150px);
        }
        .shadow-box2 {
          right: -200px;
          bottom: 0px;
          position: absolute;
          z-index: 1;
          width: 646px;
          height: 646px;
          border-radius: 646px;
          background: linear-gradient(180deg, #2B4FFE 0%, #4A299C 100%);
          filter: blur(150px);
        }
        .title-box {
          position: absolute;
          bottom: 130px;
          right: 130px;
          z-index: 2;
          .title {
            color: #FFF;
            text-align: center;
            font-family: Poppins;
            font-size: 52px;
            font-style: normal;
            font-weight: 400;
            line-height: 56px;
            letter-spacing: -1.04px;
            
            text-align: right;
          }
          .but {
            float: right;
            margin-top: 10px;
          }
        }
      }
      .introduce {
        margin-top: 60px;
        color: #424355;
        text-align: center;
        font-family: 'Poppins';
        font-size: 35px;
        line-height: 45px;
        font-weight: 600;
        //letter-spacing: 1.5px;
      }
    }
    .chioce {
      display: flex;
      justify-content: center;
      .chioce-item {
        width: 354px;
        height: 210px;
        margin: 0 20px;
        position: relative;
        &:hover {
          cursor: pointer;
          opacity: 0.8;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 32px;
        }
        .box {
          width: 80%;
          position: absolute;
          color: #36198A;
          font-size: 18px;
          bottom: 25px;
          left: 18px;
          padding: 4px 18px;
          border-radius: 100px;
          opacity: 0.95;
          background: #FBFAFB;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .stress {
            font-weight: 700;
            letter-spacing: 1px;
          }
          .ciecle {
            border-radius: 62.5px;
            background: #36198A;
            display: flex;
            width: 20px;
            height: 20px;
            padding: 6.25px;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .why-choose-us {}

    .find-jobs {
      margin-top: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      .content {
        max-width: 1400px;
        text-align: left;
        padding: 0px 104px;
        position: relative;
        .line-img {
          width: 356px;
          height: 446px;
          position: absolute;
          top: 120px;
          left: 53%;
          .line {
            position: absolute;
            top: 10px;
            left: 50%;
            transform: translateX(-50%);
          }
          .black-c {
            position: absolute;
            top: -8px;
            left: -10px;
          }
          .green-c {
            position: absolute;
            bottom: 8px;
            right: -10px;
          }
        }
        .title {
          color: #6E62E5;
          font-family: "Ray-Ban Sans";
          letter-spacing: 3px;
          font-size: 68px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          
          margin-bottom: 15px;
          margin-top: 120px;
        }
        .tip {
          color: #424355;
          font-family: Helvetica;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: 32px; /* 133.333% */
          
          margin-bottom: 12px;
        }
        .word {
          margin-top: 26px;
          color: #424355;
          font-family: Helvetica;
          font-size: 18px;
          font-style: normal;
          font-weight: 300;
          line-height: 32px; /* 177.778% */
        }
        .img-box {
          width: 415px;
          height: 561px;
          background: #F6F6F6;
          img {
            width: 300px;
            height: 460px;
            border-radius: 250px;
            object-fit: cover;
            margin: 60px 0px 0 32px;
            box-shadow: 25px 30px 30px 0px rgba(237, 216, 189, 0.8);
          }
        }
      }
    }

    .become-profession {
      width: 100%;
      background: linear-gradient(90deg, #D6D7DF 11.58%, #ECEEFF 94.04%);
      .bp-content {
        max-width: 1400px;
        padding: 51px 56px 40px;
        text-align: center;
        margin: 0 auto;
        .bp-title {
          margin-top: 15px;
          color: #6E62E5;
          font-family: "Ray-Ban Sans";
          font-size: 68px;
          font-weight: 700;
          
          letter-spacing: 3px;
        }
        .bp-tip {
          margin-top: 15px;
          color: #424355;
          font-family: Helvetica;
          font-size: 24px;
          font-weight: 700;
          line-height: 32px;
          
        }
        .bp-but {
          margin: 30px auto 40px;
        }
        .bp-item {
          width: 280px;
          height: 270px;
          border-radius: 24px;
          background-color: rgba(255, 255, 255, 0.4);
          padding: 8px;
          .bp-item-bg {
            width: 100%;
            height: 100%;
            background-image: url('~@/assets/images/identity/bp-file-bg.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            text-align: left;
            gap: 20px;
            .number {
              position: absolute;
              top: 5px;
              left: 7px;
              display: flex;
              width: 16px;
              height: 16px;
              padding: 10px;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border-radius: 100px;
              background: #6E62E5;
              gap: 10px;
              flex-shrink: 0;
              color: #FFF;
              font-family: "DIN Alternate";
              font-size: 19px;
              font-weight: 700;
              line-height: 32px;

            }
            .bp-item-title {
              color: #000;
              font-family: Helvetica;
              font-size: 18px;
              font-weight: 400;
              line-height: 20px;
              margin: 70px 38px 0;
            }
            .bp-item-content {
              color: #999;
              font-family: Helvetica;
              font-size: 16px;
              font-weight: 400;
              margin: 0 38px;
              line-height: 20px;
            }

          }
          
        }
      }
    }

    .be-a-free {
      width: 100%;
      background: #030100;
      overflow: hidden;
      position: relative;
      .bf-shadow {
        position: absolute;
        top: -150px;
        right: -150px;
        width: 646px;
        height: 646px;
        border-radius: 646px;
        background: linear-gradient(180deg, #2B4FFE 0%, #4A299C 100%);
        filter: blur(150px);
      }
      .bf-content {
        max-width: 1400px;
        width: 100%;
        margin: 0 auto;
        .bf-content-top {
          padding: 82px 85px 73px;
          border-bottom: 1px solid #424355;
          .bf-top-title {
            width: 100%;
            text-align: center;
            color: #6E62E5;
            font-family: "Ray-Ban Sans";
            font-size: 68px;
            font-weight: 700;
            letter-spacing: 1px;
            
            margin-top: 80px;
          }
          .bf-top-content {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            flex-wrap: wrap;
            gap: 4px;
            color: #fff;
            font-family: Helvetica;
            font-size: 18px;
            font-weight: 400;
            line-height: 32px; /* 228.571% */
            
          }
        }
        .bf-content-bottom {
          padding: 82px 85px 73px;
          border-bottom: 1px solid #424355;
          .bf-bottom-img {
            display: flex;
            align-items: flex-start;
            justify-content: center;
            position: relative;
            z-index: 99;
            .avtor {
              width: 72px;
              height: 72px;
              border-radius: 72px;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .color-1 { background: #7eeab1; }
            .color-2 { background: #c1adfb; }
            .color-3 { background: #2e8ffa; }
            .color-4 { background: #fdea41; }
            .line {
              margin-left: 68px;
              width: 80px;
              height: 80px;
            }
          }
          .bf-bottom-content {
            color: #fff;
            font-family: Helvetica;
            font-size: 24px;
            font-weight: 700;
            line-height: 32px;
            
          }
        }
      }
      .be-content-top {
        text-align: center;
        width: 100%;
        margin: 0 auto;
        padding: 80px 0;
        position: relative;
        .bg-position-1 {
          position: absolute;
          top: 0;
          right: -100px;
        }
        .bg-position-2 {
          position: absolute;
          left: -100px;
          bottom: -160px;
        }
        .be-tip {
          color: #FFF;
          font-family: Helvetica;
          font-size: 24px;
          font-weight: 300;
          line-height: 32px; /* 133.333% */
          margin-bottom: 73px;
        }
        .be-item-list {
          text-align: center;
        }
        .be-item {
          display: flex;
          width: 230px;
          height: 182px;
          padding: 32px 20px;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          gap: 60px;
          margin: 0 auto;
          position: relative;
          .be-num {
            position: absolute;
            right: 0;
            top: 0;
            display: flex;
            width: 26px;
            padding: 2px;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 10px;
            background: #99F5BE;
            color: #000;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 600;
            line-height: 16px; /* 100% */
            text-transform: uppercase;
          }
          .title {
            color: #F8F8F8;
            font-family: Helvetica;
            font-size: 18px;
            font-weight: 700;
          }
          .position-be {
            position: absolute;
            top: 110px;
          }
          .content {
            color: #F8F8F8;
            font-family: Helvetica;
            font-size: 14px;
            font-weight: 300;
            line-height: 20px;
          }
        }
        .be-bg-1 { background: rgba(255, 255, 255, 0.20); }
        .be-bg-2 {
          background: rgba(255, 255, 255, 0.06);
          background-image: url('~@/assets/images/identity/be-bg-flower.png'); 
          background-repeat: no-repeat;
          background-position: center center;
          background-size: cover;
        }
        .be-bg-3 { background: rgba(255, 255, 255, 0.1); }
      }
    }
    .be-title {
      color: #6E62E5;
      font-family: "Ray-Ban Sans";
      font-size: 68px;
      font-weight: 700;
      letter-spacing: 3px;
      position: relative;
      z-index: 99;
    }
    .become-experts {
      width: 100%;
      background: #030100;
      .be-content-bottom {
        overflow: hidden;
        text-align: left;
        margin: 0 auto;
        padding: 60px 74px;
        position: relative;
        .bg-position-3 {
          position: absolute;
          left: 15%;
          bottom: -200px;
        }
        .bg-position-4 {
          position: absolute;
          right: 200px;
          top: -200px;
        }
        .be-bottom-content {
          margin-top: 40px;
          display: flex;
          flex-direction: column;
          gap: 36px;
          align-items: flex-start;
          color: #FBFAFB;
          font-family: Helvetica;
          font-size: 16px;
          font-weight: 300;
          line-height: 24px; /* 150% */
        }
        .be-bottom-img {
          width: 447px;
          height: 503px;
          //object-fit: cover;
        }
      }
    }

    .bg-light-ciecle-1 {
      width: 646px;
      height: 646px;
      border-radius: 646px;
      background: linear-gradient(180deg, #2B4FFE 0%, #4A299C 100%);
      filter: blur(150px);
    }
    .bg-light-ciecle-2 {
      width: 834px;
      height: 834px;
      border-radius: 834px;
      background: linear-gradient(180deg, #4A299C 0%, #142A97 100%);
      filter: blur(150px);
    }

  }
}
</style>
